import { Button } from '@didto/ui';
import { useEffect, useRef, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';
import { useOutboxStatus } from '@/lib/outbox';

/**
 * Service-worker update flow: precache the app shell, never reload on our own. When a new build is
 * waiting we show a banner; the operator applies it when convenient (never mid-transaction).
 */
export function UpdatePrompt() {
  const [needRefresh, setNeedRefresh] = useState(false);
  // the outbox lives in memory until Phase 13: an update reloads the page and would lose it
  const box = useOutboxStatus();
  const waiting = box.pending + box.failed;
  const update = useRef<((reload?: boolean) => Promise<void>) | null>(null);
  useEffect(() => {
    const fn = registerSW({
      immediate: true,
      onNeedRefresh() {
        setNeedRefresh(true);
      },
      onRegisterError(e) {
        console.warn('[pwa] registration failed', e);
      },
    });
    update.current = fn;
  }, []);
  if (!needRefresh) return null;
  return (
    <div className="d-toasts" role="status">
      <div className="d-toast d-spread">
        <span>
          {waiting > 0
            ? 'A new version of didto. OS is ready. Update once everything waiting has been sent.'
            : 'A new version of didto. OS is ready.'}
        </span>
        <Button
          size="sm"
          variant="primary"
          disabled={waiting > 0}
          onClick={() => void update.current?.(true)}
        >
          Update now
        </Button>
      </div>
    </div>
  );
}
